import { useCallback } from "react";

import { getAdvertiseNowRedirect } from "./getAdvertiseNowRedirect";
import { trackAdvertiseNowClick } from "./trackAdvertiseNowClick";

type UseAdvertiseNowNavigationParams = {
  propertyId?: number;
};

export function useAdvertiseNowNavigation({
  propertyId,
}: UseAdvertiseNowNavigationParams = {}) {
  const handleAdvertiseClick = useCallback(() => {
    trackAdvertiseNowClick({ propertyId });
    window.open(getAdvertiseNowRedirect(), "_blank", "noopener,noreferrer");
  }, [propertyId]);

  return { handleAdvertiseClick };
}
